module.exports = __webpack_public_path__ + "img/wxxiaochengxu.a461fbe2.png";